<template>
  <div>

    <v-container>
      <v-layout fluid>

        <v-flex fluid>
          <v-item-group v-model="selected_probes" multiple>
            <v-layout row justify-space-between>
              <template v-for="probe in plate.probes">
                <v-item :key="probe.id" v-slot:default="{ active, toggle}">
                  <v-scroll-y-transition>
                    <v-chip v-if="!active" outlined
                            :color="probe.color ? probe.color: probe.dye.color"
                            @click="toggle">
                      {{probe.dye.name}}
                    </v-chip>

                    <v-chip v-if="active"
                            :color="probe.color ? probe.color : probe.dye.color"
                            @click="toggle" style="color: white;">
                      {{probe.dye.name}}
                    </v-chip>
                  </v-scroll-y-transition>
                </v-item>
              </template>

              <v-btn icon>
                <v-icon></v-icon>
              </v-btn>
            </v-layout>
          </v-item-group>
        </v-flex>

        <!-- Reset chart zoom -->
        <v-tooltip bottom open-delay="600ms" style="z-index: 200;">
          <template v-slot:activator="{ on }">
            <v-btn icon ref="btnChartReset" @click="btnChartReset_click" v-on="on">
              <v-icon>mdi-magnify-scan</v-icon>
            </v-btn>
          </template>
          <span>Reset chart zoom</span>
        </v-tooltip>

      </v-layout>
    </v-container>


    <v-layout>
      Sel.probes: {{selected_probes}}
      Sel.wells: {{selected_wells}}
    </v-layout>

    <plate-target-chart ref="chartTarget" :plate="plate"
                        :selected_wells="selected_wells"
                        :selected_probes="selected_probes">
    </plate-target-chart>

  </div>
</template>

<script>

	import format from 'string-format'
	import {mdiMagnifyScan} from '@mdi/js'
	import {
		VLayout, VCard, VCardTitle, VCardText,
		VItemGroup, VItem, VChip,
		VScrollYTransition,
	} from 'vuetify'
	import PlateTargetChart from "./charts/PlateTargetChart"


	export default {
		name: "plate-probe",

		components: {
			VLayout, VCard, VCardTitle, VCardText,
			VItemGroup, VItem, VChip,
			VScrollYTransition,
			'plate-target-chart': PlateTargetChart,
		},

		data: function () {
			return {
				selected_probes: [1,],
			}
		},

		props: {
			plate: {type: Object, default: () => null,},
			selected_wells: {type: Array, default: () => []},
		},

		watch: {
			plate: function (new_value, old_value) {
				console.debug("PlateTargetComponent.watch.plate() ")
			},
		},

		mounted: function () {
			console.log("PlateTargetComponent.mounted() ")

		},

		updated: function () {
			console.log("PlateTargetComponent.updated() ")
		},

		methods: {

			// -- Handle controls' events --

			btnChartReset_click: function (event) {
				this.$refs.chartRaw.reset()

				this.point = this.plate
					? this.plate.points.length
					: -1
			},

		}
	}
</script>

<style scoped>

</style>